import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { DateLocaleService } from "../services/date-locale-service";

RLReportParamDateInput.$inject = ["$compile", "$timeout"];
export function RLReportParamDateInput($compile: ng.ICompileService, $timeout: ng.ITimeoutService) {

    var postLinkFn = (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLReportParamDateInputController) => {

        // set controller paramKey from pre-compile
        controller.paramKey = attributes["rlReportParamDateInput"];
        // set any previous value='' from the input so its' not lost by ng-model
        controller.paramOutput = attributes["value"];
        controller.paramDisplay = attributes["display"];

        var req = attributes["allowblank"] == "false";
        element.attr("name", attributes["name"]);
        element.attr("type", "hidden");
        element.attr("value", "{{rpdiVM.paramOutput}}");

        var outerDiv = angular.element("<div></div>");
        var inputGroupDiv = angular.element("<div class='input-group'></div>");
        var displayInput = angular.element("<input type='text' class='form-control' rl-datepicker='' ng-model='rpdiVM.paramDisplay' " + (req ? "required='required'" : "") + " />").attr("placeholder", attributes["placeholder"]);
        var button = angular.element("<span class='input-group-btn'><button class='btn btn-default' type='button' title='Clear Selection' ng-click='rpdiVM.ClearSelection()'><i class='fa fa-times'></i></button></span>");

        element.wrap(outerDiv);
        element.wrap(inputGroupDiv);
        element.after(button);
        element.after(displayInput);

        // run compile on new stuff
        var compiled = $compile(element.parent());

        compiled(scope);
        //controller.Init();
        $timeout(() => {
            controller.Init();
        }, 100);
    };

    var directive: ng.IDirective = {
        restrict: "A",
        controller: RLReportParamDateInputController,
        controllerAs: "rpdiVM",
        require: "rlReportParamDateInput",
        bindToController: {
            paramOutput: "=",
            paramDisplay: "="
        },
        compile: (tElement: ng.IAugmentedJQuery, tAttrs: ng.IAttributes) => {
            // store param key for postcompile
            tElement.attr("rl-param-key", tElement.attr("rl-report-param-date-input"));
            // remove directive to prevent recursion
            tElement.removeAttr("rl-report-param-date-input");
            // set ng-model
            tElement.attr("ng-model", "rpdiVM.paramOutput");
            return postLinkFn;
        }
    };
    return directive;
}

class RLReportParamDateInputController {

    static $inject = ["$scope", "dateLocaleService"];

    paramKey: string;
    paramOutput: string;
    paramDisplay: string;

    constructor(private $scope: ng.IScope, private dateLocaleService: DateLocaleService) {
        $scope.$on('ssrsReportParamsClear', () => {
            this.paramOutput = "";
            this.paramDisplay = "";
        });
    }

    Init() {
        var localizeDate = (input: string) => {
            var moment = this.dateLocaleService.parseStorageMoment(input);
            if (moment.isValid()) {
                var localMoment = this.dateLocaleService.localizeMoment(moment);
                return localMoment.format("L");
            } else {
                return "";
            }
        };

        if (!_.isEmpty(this.paramOutput)) {
            this.paramDisplay = localizeDate(this.paramOutput);
        }

        var delocalizeDate = (input: string) => {
            var moment = this.dateLocaleService.parseMoment(input);
            if (moment.isValid()) {
                var storageMoment = this.dateLocaleService.delocalizeMoment(moment);
                return storageMoment.format("L");
            } else {
                return "";
            }
        };

        this.$scope.$watch(() => this.paramDisplay, (newValue, oldValue) => {
            if (newValue != oldValue) {
                var output = delocalizeDate(newValue);
				if (this.paramOutput !== output) {
					this.paramOutput = output;
                }
			}
        }, true);
    }

    ClearSelection() {
        this.paramOutput = "";
        this.paramDisplay = "";
    }
}
